module.exports = __webpack_public_path__ + "static/slider-arrow-mobile-968a08386ef2af6a013b184d42867adf.svg";